import React, { Component } from 'react';
import Loading from 'src/containers/_loading';
import { helps } from 'src/_helpers';
import ProjectCard from './components/ProjectCard';
import {
    buildChecksData
} from './helpers/checkDataBuilder';


class Checks extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show_forms: new Set(),
            selected_areas: {},
            is_hide: new Set(),
            activeProjects: [],
        };

        this.dataCache = {
            employeeMap: {},
            positionMap: {},
            positionsByProject: {},
            checksByEmployee: {},
            checksByProject: {}
        };

        this.handleDelete =
            this.handleDelete.bind(this);

        this.toggleForm =
            this.toggleForm.bind(this);

        this.handleHide =
            this.handleHide.bind(this);

        this.handleChangeAreas =
            this.handleChangeAreas.bind(this);
    }

    componentDidMount() {

        const {
            projects,
            hide_list
        } = this.props;

        const hiddenProjects =
            new Set();

        if (
            hide_list &&
            !helps.isEmpty(projects)
        ) {

            projects
                .filter(
                    project =>
                        project.active === 1
                )
                .forEach(project => {
                    hiddenProjects.add(
                        project.id
                    );
                });
        }

        const cache =
            this.rebuildData();

        this.dataCache = cache;

        this.setState({
            activeProjects:
                cache.activeProjects,
            is_hide:
                hiddenProjects
        });
    }

    componentDidUpdate(prevProps) {

        const changed =

            prevProps.projects !==
            this.props.projects ||

            prevProps.checks !==
            this.props.checks ||

            prevProps.positions !==
            this.props.positions ||

            prevProps.employees !==
            this.props.employees ||

            prevProps.curent_date !==
            this.props.curent_date;

        if (changed) {
            const cache =
                this.rebuildData();

            this.dataCache = cache;

            if (
                cache.activeProjects !==
                this.state.activeProjects
            ) {

                this.setState({
                    activeProjects:
                        cache.activeProjects
                });
            }
        }
    }

    shouldComponentUpdate(
        nextProps,
        nextState
    ) {

        return (

            nextProps.loading !==
            this.props.loading ||

            nextProps.checks !==
            this.props.checks ||

            nextProps.projects !==
            this.props.projects ||

            nextProps.positions !==
            this.props.positions ||

            nextProps.employees !==
            this.props.employees ||

            nextProps.curent_date !==
            this.props.curent_date ||

            nextState.show_forms !==
            this.state.show_forms ||

            nextState.selected_areas !==
            this.state.selected_areas ||

            nextState.is_hide !==
            this.state.is_hide ||

            nextState.activeProjects !==
            this.state.activeProjects
        );
    }

    rebuildData(props = this.props) {

        return buildChecksData(props);
    }

    handleDelete(e, check) {

        e.preventDefault();

        const confirmed =
            window.confirm(
                `Bạn muốn xoá Checkin-Checkout: ${check.id} ?`
            );

        if (confirmed) {
            this.props._delete(check);
        }

        return false;
    }

    toggleForm(id) {

        this.setState(prevState => {

            const forms =
                new Set(
                    prevState.show_forms
                );

            if (forms.has(id)) {
                forms.delete(id);
            }
            else {
                forms.add(id);
            }

            return {
                show_forms: forms
            };
        });
    }

    handleHide(projectId) {

        this.setState(prevState => {

            const hidden =
                new Set(
                    prevState.is_hide
                );

            if (
                hidden.has(projectId)
            ) {
                hidden.delete(projectId);
            }
            else {
                hidden.add(projectId);
            }

            return {
                is_hide: hidden
            };
        });
    }

    handleChangeAreas(
        e,
        projectId
    ) {

        const areaId =
            e.target.value;

        this.setState(prevState => ({

            selected_areas: {

                ...prevState.selected_areas,

                [projectId]:
                    areaId || ''
            }

        }));
    }

    getActiveProjects() {

        const {
            projects
        } = this.props;

        if (
            helps.isEmpty(projects)
        ) {
            return [];
        }

        return projects.filter(
            project =>
                project.active === 1
        );
    }

    render() {

        const {
            loading,
            positions,
            employees
        } = this.props;

        if (
            loading ||
            helps.isEmpty(positions) ||
            helps.isEmpty(employees)
        ) {
            return <Loading />;
        }

        const activeProjects =
            this.state.activeProjects;

        return (
            <div className="checks-container">

                <table className="table table-hover">

                    <thead className="border-bottom">

                        <tr>
                            <th
                                style={{
                                    width: '20%'
                                }}
                            >
                                Mục Tiêu
                            </th>

                            <th />

                            <th>
                                Nhân Sự
                            </th>
                        </tr>

                    </thead>

                    <tbody>

                        {
                            activeProjects.length === 0 &&
                            (
                                <tr>

                                    <td
                                        colSpan={4}
                                        className="
                                            text-center
                                            p-5
                                        "
                                    >
                                        <h4
                                            className="
                                                text-secondary
                                                mt-3
                                            "
                                        >
                                            Không tìm thấy
                                            Mục Tiêu nào!
                                        </h4>
                                    </td>

                                </tr>
                            )
                        }

                        {
                            activeProjects.map(
                                project => (

                                    <ProjectCard

                                        key={
                                            project.id
                                        }

                                        {...this.props}

                                        project={
                                            project
                                        }

                                        dataCache={
                                            this
                                                .dataCache
                                        }

                                        show_forms={
                                            this
                                                .state
                                                .show_forms
                                        }

                                        selected_areas={
                                            this
                                                .state
                                                .selected_areas
                                        }

                                        is_hide={
                                            this
                                                .state
                                                .is_hide
                                        }

                                        toggleForm={
                                            this
                                                .toggleForm
                                        }

                                        handleHide={
                                            this
                                                .handleHide
                                        }

                                        handleDelete={
                                            this
                                                .handleDelete
                                        }

                                        handleChangeAreas={
                                            this
                                                .handleChangeAreas
                                        }

                                    />

                                )
                            )
                        }

                    </tbody>

                </table>

            </div>
        );
    }
}

export default Checks;